function getTimeRemaining(endtime) {
  const total = endtime - Date.now();
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return {
    total,
    days,
    hours,
    minutes,
    seconds
  };
};

const STATES = {
  running: 'running',
};

const plural = (count, strings) => {
  return count === 1 ? strings.one : strings.other.replace('[count]', count);
};

const formatters = {
  default: ({ total, days, hours, minutes, seconds }, strings) => {
    const daysText = plural(days, strings.day);
    const hoursText = plural(hours, strings.hour);
    const minutesText = plural(minutes, strings.minute);

    if (total < 3600000) {
      return minutesText;
    }

    if (total < 86400000) {
      if (minutes === 0) {
        return hoursText;
      }

      return strings.remaining_hours_minutes
        .replace('[hours]', hoursText)
        .replace('[minutes]', minutesText);
    }

    if (total < 86400000 * 2) {
      if (hours === 0) {
        return daysText;
      }

      return strings.remaining_days_hours
        .replace('[days]', daysText)
        .replace('[hours]', hoursText);
    }

    return daysText;
  }
}

class DateCountdown extends HTMLElement {
  constructor() {
    super();

    this.dateStrings = JSON.parse(this.querySelector('[data-date-strings]').innerHTML);
  }

  connectedCallback() {
    this._endTime = Date.parse(this.getAttribute('end-time'));

    const runningEl = this.querySelector('[data-state="running"]');
    runningEl.innerHTML = runningEl.innerHTML.replace('[remaining]', `<span data-time></span>`);
    this._timeEl = runningEl.querySelector('[data-time]');

    const { total } = getTimeRemaining(this._endTime);

    if (total < 0) {
      this._setEndState();
    } else {
      this._setState(STATES.running);
      this._updateRemaining();
    }

    this.style.display = null;

    this.interval = setInterval(() => {
      this._updateRemaining();
    }, 60000);
  }

  disconnectedCallback() {

  }

  _updateRemaining() {
    const remaining = getTimeRemaining(this._endTime);

    if (remaining.total < 0) {
      clearInterval(this.interval);
      this._setEndState();
    }

    this._setRemaining(formatters.default(remaining, this.dateStrings));
  }

  _setState(state) {
    this.setAttribute('state', state);
  }

  _setRemaining(html) {
    if (!this._timeEl) return;

    this._timeEl.innerHTML = html;
  }

  _setEndState() {
    const wrapper = this.closest('[data-countdown-wrapper]');
    const endEl = this.querySelector('[data-state="ended"]');

    if (!wrapper || !endEl) return;

    wrapper.innerHTML = endEl.innerHTML;
  }
}

if (!customElements.get("date-countdown")) {
  customElements.define("date-countdown", DateCountdown);
}
